import script from "./MainVendorInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MainVendorInfo.vue?vue&type=script&setup=true&lang=js"

import "./MainVendorInfo.vue?vue&type=style&index=0&id=3c31b43e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c31b43e"]])

export default __exports__